import { useEffect } from 'react';
import { useOrders } from '../../contexs/orders-context';
import notificationSounds from '../../utils/notification-sounds';

export const VendorOrderNotification = () => {
  const { registerCallback } = useOrders();

  // When there are new orders, play the sound once
  useEffect(() => {
    const bellSound = notificationSounds.bell();

    const unregisterCallback = registerCallback(
      'VendorOrderNotification',
      (newOrders, orders) => {
        const anyUnestimatedOrder = orders.find(order => !order.estimated_at);
        const isSoundLooping = bellSound.getNumberOfLoops() === -1;

        if (anyUnestimatedOrder) {
          if (!isSoundLooping) {
            bellSound.setNumberOfLoops(-1).play();
          }

          // if there's unestimated order, even when there's new order don't
          // play the sound again.
          return;
        }

        // make sure to stop loop when there's no unestimated order
        bellSound.setNumberOfLoops(0);
        // play sound once when there's new order
        if (newOrders.length > 0) {
          bellSound.play();
        }
      },
    );

    return () => {
      unregisterCallback();
      bellSound.release();
    };
  }, []);

  return null;
};
